import { render, staticRenderFns } from "./ProjectNavDrawer.vue?vue&type=template&id=fdf04c4e&scoped=true&"
import script from "./ProjectNavDrawer.vue?vue&type=script&lang=js&"
export * from "./ProjectNavDrawer.vue?vue&type=script&lang=js&"
import style0 from "./ProjectNavDrawer.vue?vue&type=style&index=0&id=fdf04c4e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdf04c4e",
  null
  
)

export default component.exports